import { channelType, Field, NewTicket, status, Ticket, TicketSystemFieldsKey } from '../model/types';

export const getFieldInstanceFromTicket =
    (ticketDetail: NewTicket) =>
    (fieldKey: string): Field => {
        if (!ticketDetail) {
            // console.debug('getFieldInstanceFromTicket: ticketDetail is empty, will return empty field');
            return null;
        }

        if (!ticketDetail?.fieldMap) {
            // console.debug('getFieldInstanceFromTicket: ticketDetail.fieldMap is empty, will return empty field');
            return null;
        }

        if (!fieldKey) {
            // console.debug('getFieldInstanceFromTicket: fieldKey is empty, will return empty field');
            return null;
        }

        if (!ticketDetail.fieldMap?.[fieldKey]) {
            // console.debug(
            //     'getFieldInstanceFromTicket: ticketDetail.fieldMap[fieldKey] is empty, will return empty field for fieldKey',
            //     fieldKey
            // );
            return null;
        }

        return ticketDetail.fieldMap[fieldKey];
    };

export const getTicketRequester = (ticket: NewTicket): string =>
    ticket?.fieldMap?.[TicketSystemFieldsKey.requester]?.userFriendlyValue ?? 'No requester available';
export const getTicketSerializedRequester = (ticket: NewTicket): string =>
    ticket?.fieldMap?.[TicketSystemFieldsKey.requester]?.serializedValue;
export const getTicketSubject = (ticket: NewTicket): string =>
    ticket?.fieldMap?.[TicketSystemFieldsKey.subject]?.userFriendlyValue ?? 'No subject available';
export const getTicketDescription: (ticket: NewTicket) => string = (ticket) =>
    ticket?.comments?.length > 0 ? ticket?.comments?.[ticket?.comments?.length - 1]?.body ?? null : null;

export const getTicketFullStatus = (ticket: NewTicket) =>
    ticket?.fieldMap?.[TicketSystemFieldsKey.status]?.value as Ticket['status'];
export const getTicketStatus = (ticket: NewTicket): status =>
    ticket?.fieldMap?.[TicketSystemFieldsKey.status]?.userFriendlyValue as status;
export const getTicketKey = (ticket: NewTicket | Ticket): string => ticket?.key;

export const getTicketKeyNumberPart = (ticket: NewTicket): number => +(getTicketKey(ticket)?.split('-')?.[1] ?? null);

export const getTicketChannel = (ticket: NewTicket): channelType => ticket?.channel;
